import React, { useEffect } from 'react'
import { useState } from 'react'
import { Sidebar } from '../../components/Sidebar/Sidebar'
import DataTable from 'react-data-table-component'
import { TiDeleteOutline } from 'react-icons/ti'
import axios from 'axios'
import { Baseurl } from '../../../Config/Baseurl'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Link, useNavigate } from 'react-router-dom'

export const Position = () => {
  // get and set position
  toast.configure()
  const navigate = useNavigate()
  const logout = () => {
    localStorage.clear()
    navigate('/ADMS')
  }
  const [position, setPosition] = useState('')
  const [id, setId] = useState()
  const [data, setData] = useState([])
  const token = localStorage.getItem('token')
  // add new position
  const postData = async (e) => {
    e.preventDefault()
    await axios
      .post(
        Baseurl.nodeLocal + 'dropdown/saveDropdownValues',

        {
          name: position,
          value: position,
          drp_name: 'position',
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((res) => {
        toast.success(res.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
        setTimeout(() => {
          window.location.reload(false)
          setPosition('')
        }, 2000)
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
        if (err.response.status === 401) {
          logout()
        }
        setPosition('')
      })
  }

  // get all positions
  const getData = async () => {
    await axios
      .get(Baseurl.nodeLocal + 'dropdown/fetchPositions')
      .then((res) => {
        setData(res.data.data)
      })
      .catch((err) => {})
  }

  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // delete position
  const deleteData = async () => {
    await axios
      .post(
        Baseurl.nodeLocal + 'dropdown/deletePosition',
        {
          id: id,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((res) => {
        toast.success(res.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
        setTimeout(() => {
          window.location.reload(false)
        }, 2000)
      })
      .catch((err) => {})
  }

  const column = [
    {
      name: 'Sr.no',
      selector: (row) => row.id,
      sortable: true,
      width: '80px',
    },
    {
      name: 'Position',
      selector: (row) => row.name,
    },
    {
      name: 'Action',
      cell: (row) => {
        return (
          <>
            <TiDeleteOutline
              className="deletebtn"
              data-bs-target="#deleteModal"
              data-bs-toggle="modal"
              onClick={() => {
                setId(row.id)
              }}
            />
          </>
        )
      },
    },
  ]

  return (
    <>
      <Sidebar />
      <div className="container edituser mt-5 p-4">
        <div className=" mt-3">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/home" className="link text-primary">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Position Add/View
              </li>
            </ol>
          </nav>
        </div>

        <div className="row">
          <div className="card col-md-4 p-4" style={{ height: '230px' }}>
            <h5>Add Position</h5>
            <form onSubmit={postData}>
              <div className="mb-3 mt-3">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label"
                >
                  Position
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="exampleFormControlInput1"
                  name="position"
                  value={position}
                  onChange={(e) => {
                    setPosition(e.target.value)
                  }}
                  required
                />
              </div>
              <div>
                <button className="btn btn-primary btn-sm" type="submit">
                  Submit
                </button>
              </div>
            </form>
          </div>
          <div className="col-md-8 p-4">
            {' '}
            <h5 className="text-primary">View Positions</h5>
            <DataTable
              columns={column}
              data={data}
              pagination
              highlightOnHover
            />
          </div>
        </div>

        {/* cofimartion to delete position */}
        <div
          className="modal"
          tabIndex="-1"
          id="deleteModal"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Alert</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete the data ?</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    deleteData()
                  }}
                  data-bs-dismiss="modal"
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
